import { paths } from '@luxuryescapes/contract-business'

export type ProfilePutResult = paths['/api/business-traveller/me/profile']['put']['responses'][200]['content']['application/json']['result']
export type ProfilePutPayload = paths['/api/business-traveller/me/profile']['put']['requestBody']['content']['application/json']

export function mapProfileResponseToUserDetails(result: ProfilePutResult | null | undefined): Partial<App.AuthAccount> {
  if (!result) return { email: '', givenName: undefined, surname: undefined }
  return {
    givenName: result.givenName ?? undefined,
    surname: result.surname ?? undefined,
    title: (result.title as App.Title) ?? undefined,
    email: result.email ?? '',
    dob: result.dob ?? undefined,
    postcode: result.postcode ?? undefined,
    phonePrefix: result.phone_prefix ?? undefined,
    phone: result.phone ?? undefined,
    countryCode: result.country_code ?? undefined,
    gender: (result.gender as App.AuthAccount['gender']) ?? undefined,
    middleName: result.middleName ?? undefined,
  }
}
